import toLower from './toLower';

const PRODUCT_HIGHLIGHTS_REGION = 'Product Highlights';
const DOCUMENT_UPLOAD_PATH = '/documents/uploads/';
const FILE_TYPE = 'pdf';

const fileNameFromHref = href => {
  const path = href.split('?')[0].split('#')[0];
  const last = path.split('/').filter(Boolean).pop() || '';
  try {
    return decodeURIComponent(last);
  } catch {
    return last;
  }
};

const setAttr = (el, name, value) => {
  if (!value) return;
  if (el.getAttribute(name) !== value) el.setAttribute(name, value);
};
const removeAttr = (el, name) => {
  if (el.hasAttribute(name)) el.removeAttribute(name);
};

const trackFleetwoodProductHighlightsDownloads = (container, { buildType, productType } = {}) => {
  if (!container) return undefined;

  const isFleetwood = buildType === 'Product::Fleetwood';
  const section = container.closest('[data-am-region]');
  if (!isFleetwood || section?.dataset?.amRegion !== PRODUCT_HIGHLIGHTS_REGION) return undefined;

  const isUploadLink = link => (link.getAttribute('href') || '').includes(DOCUMENT_UPLOAD_PATH);

  const applyAttrs = link => {
    const tabEl = link.closest('[data-tab-heading]');
    setAttr(link, 'data-track', 'file-download');
    setAttr(link, 'data-track-file-name', toLower(fileNameFromHref(link.getAttribute('href') || '')));
    setAttr(link, 'data-track-file-type', FILE_TYPE);
    setAttr(link, 'data-track-product-type', toLower(productType));
    if (tabEl) setAttr(link, 'data-track-doc-type', toLower(tabEl.dataset.tabHeading));
    // Removed here because another component tags these links with a destination.
    removeAttr(link, 'data-track-destination');
  };

  const applyToLink = link => {
    if (isUploadLink(link)) applyAttrs(link);
  };

  container.querySelectorAll('a[href]').forEach(applyToLink);

  // Watch only the container for links that render after the initial pass. The
  // product type comes in synchronously as an option, so there's no need to
  // observe the wider document for the Technical Resources section.
  const observer = new MutationObserver(mutations => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const links = node.tagName === 'A' ? [node] : Array.from(node.querySelectorAll('a[href]'));
        links.forEach(applyToLink);
      });
    });
  });
  observer.observe(container, { childList: true, subtree: true });

  return () => observer.disconnect();
};

export default trackFleetwoodProductHighlightsDownloads;
